<template>
  <div>
    <div class="m-item row">
      <span class="item-left col-auto">{{title}}</span>
      <span class="item-right col ellipsis text-right" @click.stop="itemClicked">
        <span class="m-sub ellipsis" :class="{'assertive':subheadLight}">{{subhead}}</span>
        <i v-if="showIcon" class="icon " :class="iconClass?iconClass:'icon-arrow-right'"></i>
      </span>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    subhead: {
      type: String,
      default: ''
    },
    subheadLight: {
      type: Boolean,
      default: false
    },
    iconClass: {
      type: String,
      default: 'icon-arrow-right'
    },
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    itemClicked () {
      this.$emit('itemClicked')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/scss" lang="scss" scoped>
.m-item {
  display: flex;
  flex: 1;
  justify-content: space-between;
  width: 100%;
  height: 50px;
  line-height: 50px;
  padding-left: 15px;
  border-bottom: 1px solid #f5f5f5;
  background-color: #ffffff;
  font-size: 16px;
  .item-right {
    width: 0;
    display: inline-flex;
    padding: 0 15px;
    .ellipsis{
      padding-left: 25px;
      width: 100%;
    }
    .m-sub {
      font-size: 14px;
      color: #999999;
    }
    .icon {
      padding-left: 10px;
      color: #999999;
    }
  }
}
</style>
